<template>
  <div>
    <div class="fixed_page" id="blurry">
      <div class="get-started popup_bg">
        <div class="fixed_page">
          <div class="notifications_box_outer">
            <h1>{{ getTranslations.home_notifications_title }}</h1>
            <div class="notifications_box">
              <ul v-for="(notificationBar, index) in notificationArraysBar" :key="index">
                <div class="notification_content">
                  <div class="date">
                    <span>{{ notificationBar.notificationDate | getFormatForBar }}</span>
                  </div>
                  <div v-for="(notification, index) in notificationArrays" :key="'B' +index"
                       v-if="hasTheSameDate(notification.id, notificationBar.notificationDate)">
                    <div class="notification_row">
                      <img :src="showCorrectImg(notification.data)" alt="">
                      <p>
                        <span>
                          {{ notificationTranslationMethod(notification.data.notificationCategoryDTO.name) }}
                        </span>
                        {{ notificationTranslationMethodText(notification.data) }}
                      </p>
                    </div>
                    <a v-if="notificationsWithoutCheckItButton(notification.data.notificationCategoryDTO.name)"
                       style="cursor: pointer" class="see_more" @click.prevent="checkIt(notification.data)">
                      {{ getButtonTranslation(notification.data.notificationCategoryDTO.name) }}
                    </a>
                    <div class="noti_horizontal_line"></div>
                  </div>
                </div>
              </ul>
            </div>
            <a v-if="displayDifferentDaysNotifications.length !== 0" style="cursor: pointer" @click.prevent="clearData" class="clear_notifications">
              {{ getTranslations.home_notifications_clear_all }}</a>
          </div>
          <div class="circle_background popup_circle_bg"></div>
        </div>
      </div>
    </div>
    <component :is="currentNotificationModal"
               v-bind="currentProperties"
               @read="updateReadStatus"
               @close="closeHomeModal"
               @openNewModal="openNewModal($event)"/>
  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }] */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import LevelUp from './modals/LevelUp';
import PrizeDetails from './modals/PrizeDetails';
import Ranking from './modals/Ranking';
import SpinWheel from './modals/spinwheel/SpinWheel';
import SpinWheelPrize from './modals/spinwheel/SpinWheelPrize';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import BonusMultiplier from './modals/bonus_phases/PointsMultiplier';
import BundleDiscount from './modals/bonus_phases/BundleDiscount';
import NewAchievement from './modals/achievements/NewAchievement';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'notifications',
  components: {
    NewAchievement,
    SpinWheelPrize,
    BundleDiscount,
    BonusMultiplier,
    BonusDaily,
    SpinWheel,
    LevelUp,
    PrizeDetails,
    Ranking,
  },
  mixins: [RoundUpMixin, NewGameMixin],
  data() {
    return {
      currentNotificationModal: null,
      prizeDetails: {
        winDTO: {
          name: null,
          imageUrl: null,
        },
      },
      gameType: null,
      currentModal: null,
      showedModal: false,
      showmore: false,
      extraArrays: [],
      userNotifications: [],
      displayNotifications: [],
      displayDifferentDaysNotifications: [],
      displayBlackBar: [],
      unreadNotifications: 0,
      moreNotifications: false,
      prizeModalName: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line
    console.log('==> inside component\'s beforeRouteEnter:');
    if (process.env.NODE_ENV !== 'production') {
      const deepCloneForStrictError = JSON.parse(JSON.stringify(localStorage.getItem('locale')));
      moment.locale(deepCloneForStrictError);
    } else {
      moment.locale(localStorage.getItem('locale'));
    }
    next();
  },
  created() {
    this.getUserNotifications().then(() => {
      this.numberOfUnreadNotifications();
    });
  },
  mounted() {
    this.numberOfUnreadNotifications();
    if (this.unreadNotifications > 0) {
      this.changeNotificationReadStatus().then(() => {
        this.getUserNotifications().then(() => {
          // eslint-disable-next-line
          this.userNotifications = this.notifications;
          this.numberOfUnreadNotifications();
        });
      });
    }
  },
  methods: {
    ...mapActions('profile', [
      'changeNotificationReadStatus',
      'getUserNotifications',
      'getUserLoginDetails',
      'clearNotifications',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'updatePhaseBonusModalToBeDisplayed',
      'saveBonusDailyModal',
      'setCheckedNotificationId',
      'setShowmodalForRanking',
      'setCheckedNotificationReadStatus',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
    ]),
    closeHomeModal() {
      /* eslint-disable */
      $(".popup_box").fadeOut(200);
      $(".overlay").fadeOut(200);
      $('.modal, .modal-overlay').fadeOut();
      $("body").removeClass("modal-open");
      /* eslint-enable */
      this.currentNotificationModal = null;
    },
    updateReadStatus() {
      if (this.checkedNotificationId) {
        this.$axios.get(`api/changeNotificationStatus?notificationId=${this.checkedNotificationId}`);
      }
      this.userNotifications = this.notifications;
      this.numberOfUnreadNotifications();
    },
    numberOfUnreadNotifications() {
      // comment next line for dev purpose
      this.userNotifications = this.notifications;
      this.unreadNotifications = (this.userNotifications) ? this.userNotifications.filter(notification => !notification.readStatus).length : 0;
    },
    showCorrectImg(notification) {
      return notification.notificationCategoryDTO.imgUrl;
    },
    notificationsWithoutCheckItButton(name) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === name)[0];
      let notificationWithButton = true;
      if (notification) {
        notificationWithButton = notification.notificationButtonTranslation ? notification.notificationButtonTranslation : false;
      }
      return notificationWithButton;
    },
    notificationTranslationMethodText(notificationData) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.value === notificationData.notificationCategoryDTO.value)[0];
      if (notification) {
        let textBefore = notification.notificationTextBeforeTranslation || '';
        if (textBefore) {
          textBefore = this.getTranslations[textBefore];
        }
        let textAfter = notification.notificationTextAfterTranslation || '';
        if (textAfter) {
          textAfter = this.getTranslations[textAfter];
        }
        if (notification.dynamicText) {
          if (!textBefore && !textAfter) return '';
          return `${textBefore} ${moment(notificationData.startDate).format('LLL')} ${textAfter} ${moment(notificationData.endDate).format('LLL')}`;
        }
        if (!textAfter) return `${textBefore}`; // Invitation Registration, Spin Wheel, Achievement
        return `${textBefore} ${notificationData.text} ${textAfter}`;
      }
      return this.getTranslations[notificationData.text];
    },
    notificationTranslationMethod(text) {
      /* eslint-disable */
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === text)[0];
      if(notification) text = notification.notificationTitleTranslation;
      return this.getTranslations[text];
      /* eslint-enable */
    },
    getButtonTranslation(text) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === text)[0];
      if (notification) {
        return this.getTranslations[notification.notificationButtonTranslation];
      }
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_check_it')).toString()];
    },
    displayMore() {
      this.moreNotifications = true;
      this.extraArrays = [];
      this.displayBlackBar = [];
    },
    checkIt(notification) {
      this.currentNotificationData = notification;
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        if (this.displayDifferentDaysNotifications[i].data.id === notification.id && !this.checkIfNotificationIsOfType(this.userNotifications[i], /PendingSpinningWheelGame|Achievement/g)) {
          this.displayDifferentDaysNotifications[i].data.readStatus = true;
          break;
        }
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIfNotificationIsOfType(notification, typeRegex) {
      return typeRegex.test(notification.notificationCategoryDTO.value);
    },
    sendNotificationIdtoDB(notificationIdtoDB) {
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.ChangeUsernameOrPin.text) {
        this.$router.push('profile');
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BonusPhasesDaily.text) {
        const modalData = {
          quantity: notificationIdtoDB.bonusPoints,
          loginStreak: notificationIdtoDB.gamesEarned,
          dailyBonusType: notificationIdtoDB.gameType,
        };
        this.saveBonusDailyModal(modalData);
        this.storeModalForHomePage(BonusDaily);
      }
      // if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.topRanking.text) {
      //   const notificationRankingData = {
      //     userLevel: notificationIdtoDB.userLevel,
      //     bonusPoints: notificationIdtoDB.bonusPoints,
      //     gamesEarned: notificationIdtoDB.gamesEarned,
      //   };
      //   // temp
      //   this.setShowmodalForRanking({ notificationRankingObject: notificationRankingData });
      // }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.SpinWheel.text) {
        this.setCheckedNotificationId({ value: notificationIdtoDB.id });
        this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
        this.setNotificationRewardId({ value: '' });
        this.setNotificationRewardName({ value: notificationIdtoDB.text });
        this.setNotificationPrizeWon({ value: notificationIdtoDB.hasWon });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BundleDiscount.text ||
        notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BonusPointsPhase.text) {
        let modal;
        switch (notificationIdtoDB.notificationCategoryDTO.name) {
        case 'Bonus Points Phase':
          modal = BonusMultiplier;
          break;
        case 'Bundle Discount':
          modal = BundleDiscount;
          break;
        default:
          modal = null;
          break;
        }
        const modalData = {
          start: notificationIdtoDB.startDate,
          end: notificationIdtoDB.endDate,
          multiplier: notificationIdtoDB.text,
        };
        this.updatePhaseBonusModalToBeDisplayed(modalData);
        this.storeModalForHomePage(modal);
      }
      // } else if(notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.topRanking.text) {
      //   this.storeModalForHomePage(Ranking);
      //   this.showModal();
      // }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.Achievement.text) {
        this.setCheckedNotificationId({ value: notificationIdtoDB.id });
        this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
        this.setNotificationRewardId({ value: notificationIdtoDB.gameId });
      }

      this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
    },
    showModalMethod(notificationModalName) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === notificationModalName)[0];
      if (notification) {
        if (notification.showModal) {
          this.currentNotificationModal = notification.showModal;
        }
      }
      this.showModal();
    },
    openNewModal(event) {
      this.prizeModalName = event;
      this.currentNotificationModal = 'SpinWheelPrize';
      this.showModal();
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      vm.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          vm.getUserNotifications().then(() => {
            vm.userNotifications = this.notifications;
            vm.numberOfUnreadNotifications();
          });
          vm.currentNotificationModal = null;
          vm.storeModalForHomePage(null);
        });
      });
      /* eslint-enable */
    },
    clearData() {
      this.clearNotifications().then(() => {
        this.displayNotifications = [];
        this.displayDifferentDaysNotifications = [];
        this.displayBlackBar = [];
        this.extraArrays = [];
        this.showmore = false;
        this.userNotifications = [];
      });
    },
    hasTheSameDate(notificationDate1, notificationDate2) {
      return (moment(notificationDate1).format('L') === moment(notificationDate2).format('L'));
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'notifications',
      'achievements',
      'jwtInVuex',
    ]),
    ...mapGetters('common', [
      'getNotificationsNames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationsKeys',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGrandPrize',
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
    ]),
    currentProperties() {
      if (this.currentNotificationModal === 'NewAchievement') {
        const { text } = this.currentNotificationData;

        const achievementData = this.achievements
          .flatMap(a => a.achievementDTOs)
          .flatMap(ad => ad.achievementLevelDTOs.map(l => ({ ...l, category: ad.achievementName })))
          .filter(al => `${al.category}_${al.achievementLevelName}` === text)[0];

        // eslint-disable-next-line
        const { category, prizeValue, prizeType, awardedPrizeDesc, awardedCorrelationId, threshold } = achievementData;

        this.setNotificationRewardName({ value: awardedPrizeDesc });
        this.setNotificationPrizeWon({ value: !!awardedCorrelationId });

        return {
          achievementInfo: {
            achievementLevelName: text.replace(`${category}_`, ''),
            image: `static/images/achievements/PNGs/${category.toLowerCase()}.png`,
            threshold,
            prizeValue,
            prizeType,
            categoryName: category,
          },
        };
      } else if (this.currentNotificationModal === 'SpinWheelPrize') {
        return {
          prizeInfo: {
            prizeName: this.prizeModalName,
          },
        };
      }
      return null;
    },
    notificationArraysBar() {
      /* eslint-disable */
      this.displayNotifications = [...this.userNotifications];
      this.displayNotifications = this.displayNotifications.filter(e => e);// delete null values
      this.displayDifferentDaysNotifications = [];
      this.displayBlackBar = [];
      for (let i = 0; i < this.displayNotifications.length; i += 1) {
        if (i === 0) {
          const first = {
            id: this.displayNotifications[i].notificationDate,
            data: this.displayNotifications[i],
          };
          this.displayDifferentDaysNotifications.push(first);
        } else {
          let notific = {
            id: '',
            data: '',
          };
          for (let k = 0; k < this.displayDifferentDaysNotifications.length; k += 1) {
            if (moment(this.displayNotifications[i].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[k].data.notificationDate).format('L')) {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
              break;
            } else {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
            }
          }
          this.displayDifferentDaysNotifications.push(notific);
        }
      }
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        const notific = {
          id: '',
          notificationDate: '',
        };
        if (i === 0) {
          const first = {
            id: this.displayDifferentDaysNotifications.length - 1,
            notificationDate: this.displayDifferentDaysNotifications[i].data.notificationDate,
          };
          this.displayBlackBar.push(first);
        } else {
          let isAlreadyInArray = false;
          for (let k = 0; k < this.displayBlackBar.length; k += 1) {
            isAlreadyInArray = false;
            if (moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L')) {
              break;
            } else if (!(moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L'))) {
              isAlreadyInArray = true;
              notific.id = k;
              notific.notificationDate = this.displayDifferentDaysNotifications[i].data.notificationDate;
            }
          }
          if (isAlreadyInArray) {
            this.displayBlackBar.push(notific);
          }
        }
      }
      this.displayBlackBar.sort((a, b) => b.notificationDate - a.notificationDate);
      return this.displayBlackBar;
      /* eslint-enable */
    },
    notificationArrays() {
      return this.displayDifferentDaysNotifications;
    },
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getFormatForBar(dateInBar) {
      return moment(dateInBar).format('DD/MM');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Notifications.vue